import { getModeledChampionships as getStoreItems } from 'selectors'
import { useSelector } from 'react-redux'
import { championships as rawFixtures } from '@fedsim/imports'

import { mapImported, modelDefaultValues } from '../helpers'

import Form from './form'

const sortByMaxPoints = (a, b) => {
  if (a?.minPoints > b?.minPoints) {
    return -1
  }
  if (a?.minPoints < b?.minPoints) {
    return 1
  }
  return 0
}

export const useChampionships = () => {
  const rawImported: any[] = useSelector(getStoreItems)
  const imported = rawImported.map(model => modelDefaultValues(Form, model)).sort(sortByMaxPoints)
  const fixtures = rawFixtures.map(model => modelDefaultValues(Form, model)).sort(sortByMaxPoints)
  const mapped = mapImported(fixtures, imported)
  const notImported = mapped.filter(item => item.imported === false).sort(sortByMaxPoints)

  return { mapped, fixtures, imported, notImported }
}
